import { AsyncPipe } from '@angular/common';
import { Component, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { Store } from '@ngrx/store';

import {
  BadgeCounterComponent,
  NtyToolbarFilterChipListComponent,
  ToolbarModule,
} from '@ninety/mobile/platform/components';
import {
  FeatureFlagKeys,
  featureFlagSelectors,
  PeopleTabKey,
  selectVisiblePeopleTabs,
} from '@ninety/mobile/platform/state';

@Component({
  selector: 'nty-people-toolbar',
  imports: [AsyncPipe, ToolbarModule, BadgeCounterComponent, NtyToolbarFilterChipListComponent],
  template: `
    @let showFilterChips = showFilterChips$ | async;

    <nty-toolbar title="People" [badgeCount]="badgeCount">
      <nty-top-toolbar-content>
        <ng-content />
      </nty-top-toolbar-content>

      @if (showFilterChips) {
        <nty-toolbar-filter-chip-list>
          <ng-content select="terra-chip" ngProjectAs="terra-chip" />
        </nty-toolbar-filter-chip-list>
      }

      @for (tab of tabs$ | async; track tab.key) {
        <nty-toolbar-link-btn [href]="tab.route">
          {{ tab.label }}
          @if (countFor(tab.key)) {
            <nty-badge-counter color="light" size="small">{{ countFor(tab.key) }}</nty-badge-counter>
          }
        </nty-toolbar-link-btn>
      }
    </nty-toolbar>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: `
    ion-badge {
      margin-left: 8px;
    }
  `,
})
export class PeopleToolbarComponent {
  @Input() badgeCount?: number;

  @Input() assessmentsCount?: number;

  @Input() discussionsCount?: number;

  private store = inject(Store);

  protected tabs$ = this.store.select(selectVisiblePeopleTabs);
  protected showFilterChips$ = this.store.select(featureFlagSelectors.selectById(FeatureFlagKeys.filterChips));

  protected countFor(key: PeopleTabKey): number | undefined {
    switch (key) {
      case PeopleTabKey.Discussions:
        return this.discussionsCount;
      case PeopleTabKey.Assessments:
        return this.assessmentsCount;
      default:
        return undefined;
    }
  }
}
